module.exports = __webpack_public_path__ + "static/img/作品71.b82304a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设计市场/作品71.png
// module id = DZg5
// module chunks = 1